module.exports = __webpack_public_path__ + "static/media/aw-rewards-en.ce0661e5.png";